import * as React from "react";
import { TableViewAction } from "./TableViewAction";
import { FunctionAction } from "./FunctionAction";
import { LinkAction } from "./LinkAction";

interface ActionButtonProps {
    action: TableViewAction,
    entity: any
}

export const ActionButton: React.FC<ActionButtonProps> = props => {
    return <React.Fragment>
        {/* FunctionAction case */}
        {props.action.hasOwnProperty("actionFunction") && <button
            className="btn btn-sm btn-default"
            disabled={!(props.action.enabled &&
                (!(props.action as FunctionAction).enabledFunction ||
                    ((props.action as FunctionAction).enabledFunction &&
                        (props.action as FunctionAction).enabledFunction(props.entity))))}
            onClick={() => {
                (props.action as FunctionAction).actionFunction(props.entity);
            }}
        >
            <i className="material-icons align-middle">
                {props.action.icon}
            </i>
            <span className="d-none d-sm-inline-block align-middle">
                {props.action.text}
            </span>
        </button>}
        {/* LinkAction case */}
        {props.action.hasOwnProperty("url") && props.action.enabled && (
            <a
                className="btn btn-sm btn-default"
                href={(props.action as LinkAction).url + "/" + props.entity.id}
            >
                <i className="material-icons">{props.action.icon}</i>
                <span className="d-none d-sm-block">
                    {props.action.text}
                </span>
            </a>
        )}</React.Fragment>
}